import { Button, Flex, Text, Link as ChakraLink, useMediaQuery } from '@chakra-ui/react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import Link from 'next/link';
import { configFile } from '@/config';
import { handleGTMClick } from '@/helpers/handleGTMClick';

interface PathButtonIds {
  [key: string]: string;
}

const ITEM_PATH_TO_ID: PathButtonIds = {
  'seo-para-startups': 'scenario_startups',
  'seo-para-lojas-virtuais': 'scenario_ecommerce',
  'migracao-de-sites': 'scenario_migration',
  'auditoria-de-seo': 'scenario_audit',
  'seo-para-blogs': 'scenario_blogs',
  'consultoria-em-seo': 'scenario_seo',
  'local-seo': 'scenario_local_seo',
  conteudo: 'scenario_content',
  'digital-analytics': 'scenario_analytics',
  'politica-de-privacidade': 'scenario_privacy',
};

export default function ServicesBannerComponent({ data }: any) {
  const [isMobileScreen] = useMediaQuery('(max-width: 991px)');
  const currentLinkRef = useRef<HTMLAnchorElement | null>(null);
  const currentServiceRef = useRef<HTMLDivElement | null>(null);
  const sortedData = [...data].sort((a: any, b: any) => a.id - b.id);
  const router = useRouter();

  useEffect(() => {
    if (isMobileScreen) {
      if (currentServiceRef.current) {
        currentServiceRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }, [isMobileScreen]);

  const scrollLeft = () => {
    const container = document.getElementById('services-banner-container');

    if (container) {
      container.scrollLeft -= container.offsetWidth;
    }
  };

  const scrollRight = () => {
    const container = document.getElementById('services-banner-container');

    if (container) {
      container.scrollLeft += container.offsetWidth;
    }
  };

  return (
    <Flex
      id="services-banner-container"
      alignItems="center"
      maxW="996px"
      m="0 auto"
      overflowX="scroll"
      sx={{
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
    >
      <Flex alignItems="center">
        {sortedData.map((item: any, index: number) => (
          <ChakraLink
            id={ITEM_PATH_TO_ID[item.attributes.url]}
            onClick={handleGTMClick}
            onAuxClick={handleGTMClick}
            as={Link}
            href={item.attributes.url}
            key={index}
            p="0 !important"
            ref={router.pathname.includes(item.attributes.url) ? currentLinkRef : null}
          >
            <Flex
              id={item.attributes.url}
              ref={router.pathname.includes(item.attributes.url) ? currentServiceRef : null}
              direction="column"
              h="180px"
              gap="16px"
              p="32px"
              minW={{ base: '145px', lg: '250px' }}
              alignItems="center"
              justifyContent="center"
              _hover={{ bgColor: 'gray.300' }}
              borderRight={index === 3 ? 'none' : '1px solid #E5E5E5'}
              bgColor={router.pathname.includes(item.attributes.url) ? 'teal.500' : '#F1F6FF'}
              borderRadius={{
                base: '0',
                lg: index === 0 ? '16px 0 0 16px' : index === 3 ? '0 16px 16px 0' : '0',
              }}
            >
              {router.pathname.includes(item.attributes.url) ? (
                <Image
                  src={
                    index === 0
                      ? '/images/services-banner-component/iconhover1.svg'
                      : index === 1 /* eslint-disable */
                      ? '/images/services-banner-component/iconhover2.svg'
                      : index === 2
                      ? '/images/services-banner-component/iconhover3.svg'
                      : '/images/services-banner-component/iconhover4.svg'
                  }
                  alt="icon"
                  width={48}
                  height={48}
                />
              ) : (
                <Image
                  src={
                    index === 0
                      ? '/images/services-banner-component/icon1.svg'
                      : index === 1
                      ? '/images/services-banner-component/icon2.svg'
                      : index === 2
                      ? '/images/services-banner-component/icon3.svg'
                      : '/images/services-banner-component/icon4.svg'
                  }
                  alt="icon"
                  width={48}
                  height={48}
                />
              )}

              <Text
                fontSize="16px"
                lineHeight="24px"
                fontWeight="700"
                textAlign="center"
                color={
                  router.pathname.includes(item.attributes.url)
                    ? configFile.tertiaryAccentColor
                    : configFile.elevenAccentColor
                }
              >
                {item.attributes.title}
              </Text>
            </Flex>
          </ChakraLink>
        ))}
      </Flex>
      <Flex position={{ base: 'absolute' }} display={{ base: 'flex', lg: 'none' }} right="20px" bottom="-20px">
        <Button
          id="scenario_scroll_left"
          onClick={(e) => handleGTMClick(e, () => scrollLeft())}
          aria-label="scroll left"
          w="40px"
          h="40px"
          p="12px"
          bgColor="teal.400"
          color="white"
          borderRightRadius="0"
        >
          <ChevronLeftIcon />
        </Button>
        <Button
          id="scenario_scroll_right"
          onClick={(e) => handleGTMClick(e, () => scrollRight())}
          aria-label="scroll right"
          w="40px"
          h="40px"
          p="12px"
          bgColor="teal.500"
          color="white"
          borderLeftRadius="0"
        >
          <ChevronRightIcon />
        </Button>
      </Flex>
    </Flex>
  );
}
